import * as React from 'react';

import SVGBase from '../svg-base/svg-base';

export interface NewReleaseReportingProps {
    fill?: string;
    title?: string;
    height?: string;
    width?: string;
    viewBox?: string;
}

const NewReleaseReporting: React.FunctionComponent<React.PropsWithChildren<NewReleaseReportingProps>> = ({
    fill,
    title,
    height,
    width,
    ...rest
}: NewReleaseReportingProps) => (
    <SVGBase viewBox="0 0 49.95 49.95" height={height} width={width} title={title} fill={fill} {...rest}>
        <path
            fill="#ccefff"
            d="M40.57,25.53a1.72,1.72,0,0,1-1.71-1.71V14.44H20.43a.38.38,0,0,0,0,.31l2.08,6.4a1.46,1.46,0,0,1-2.25,1.63l-5.44-4a.41.41,0,0,0-.49,0l-5.44,4a1.46,1.46,0,0,1-2.25-1.63l2.08-6.4a.42.42,0,0,0,0-.31H2.29A2.34,2.34,0,0,0,0,16.82V47.58A2.33,2.33,0,0,0,2.29,50H47.66A2.33,2.33,0,0,0,50,47.58v-22Zm-28,18.52a.88.88,0,0,1-.88.88H7.26a.87.87,0,0,1-.88-.88V33.13a.87.87,0,0,1,.88-.88h4.47a.88.88,0,0,1,.88.88Zm10,0a.84.84,0,0,1-.84.84H17.21a.83.83,0,0,1-.84-.84V29a.84.84,0,0,1,.84-.84h4.55a.85.85,0,0,1,.84.84Zm10,.09a.76.76,0,0,1-.76.75H27.11a.76.76,0,0,1-.75-.75v-9.5a.86.86,0,0,1,.86-.86h4.51a.87.87,0,0,1,.86.86Zm10,0a.76.76,0,0,1-.76.75H37.1a.76.76,0,0,1-.75-.75V28.88a.76.76,0,0,1,.75-.76h4.72a.76.76,0,0,1,.76.76Z"
        />
        <rect fill="#40c5ff" x="6.38" y="32.25" width="6.23" height="12.68" rx="0.88" />
        <rect fill="#40c5ff" x="16.37" y="28.12" width="6.23" height="16.81" rx="0.84" />
        <path
            fill="#40c5ff"
            d="M31.73,33.82H27.22a.86.86,0,0,0-.86.86v9.5a.76.76,0,0,0,.75.75h4.72a.76.76,0,0,0,.76-.75v-9.5A.87.87,0,0,0,31.73,33.82Z"
        />
        <rect fill="#40c5ff" x="36.35" y="28.12" width="6.23" height="16.81" rx="0.76" />
        <path
            fill="#40c5ff"
            d="M8.69,14.75l-2.08,6.4a1.46,1.46,0,0,0,2.25,1.63l5.44-4a.41.41,0,0,1,.49,0l5.44,4a1.46,1.46,0,0,0,2.25-1.63l-2.08-6.4a.38.38,0,0,1,0-.31.29.29,0,0,1,.12-.15L26,10.34a1.46,1.46,0,0,0-.86-2.65H18.4A.42.42,0,0,1,18,7.41L15.93,1a1.46,1.46,0,0,0-2.78,0l-2.08,6.4a.4.4,0,0,1-.39.28H4a1.46,1.46,0,0,0-.86,2.65l5.44,3.95a.44.44,0,0,1,.12.15A.42.42,0,0,1,8.69,14.75Z"
        />
        <path
            fill="#99e0ff"
            d="M49.06,23.24l-7.44-7.82a3.14,3.14,0,0,0-2.27-1h-.49v9.38a1.72,1.72,0,0,0,1.71,1.71H50v-.05A3.25,3.25,0,0,0,49.06,23.24Z"
        />
    </SVGBase>
);

export default NewReleaseReporting;
